import APIClient from '@/shared/http/clients/api'

const resourceName = 'atendimento'
const APICore = process.env.APIBaseURLCore

const GetConversations = (config = {}) => APIClient.post(`${APICore}/${resourceName}/conversas`, config)
const GetConversationMessages = (protocolo, config = {}) => APIClient.get(`${APICore}/${resourceName}/conversas/${protocolo}`, config)
const GetUsenames = (config = {}) => APIClient.post(`${APICore}/${resourceName}/usuarios/usernames`, config)
const GetPersonDetails = (protocolo, config = {}) => APIClient.get(`${APICore}/${resourceName}/conversas/${protocolo}/detalhes`, config)
const GetTipos = (protocolo, config = {}) => APIClient.get(`${APICore}/${resourceName}/finalizacao/tiposFinalizacao`, config)
const GetQrCode = (data, config = {}) => APIClient.post(`${APICore}/${resourceName}/qrcode`, data, config)
const GetPages = (config = {}) => APIClient.post(`${APICore}/${resourceName}/paginas`, config)
const GetMetricasResumo = (config = {}) => APIClient.post(`${APICore}/${resourceName}/metricas/resumo`, config)
const CreateConversation = (config = {}) => APIClient.post(`${APICore}/${resourceName}/conversations/createConversation`, config)
const SendMessage = (protocolo, data, config = {}) => APIClient.post(`${APICore}/${resourceName}/conversas/${protocolo}/enviar-mensagem`, data, config)
const GetArchive = (config = {}) => APIClient.post(`${APICore}/${resourceName}/arquivo`, config)
const GetImageId = (config = {}) => APIClient.post(`${APICore}/${resourceName}/imagemId`, config)
const GetVideoId = (config = {}) => APIClient.post(`${APICore}/${resourceName}/videoId`, config)
const UpdateConversationNickname = (data, config = {}) => APIClient.put(`${APICore}/${resourceName}/conversation/nickname`, data, config)
const UpdateHsmMedia = (id, payload, config = {}) => APIClient.patch(`${APICore}/hsm/${id}/media`, payload, config)

const AtendimentoRepository = {
  GetQrCode,
  GetConversations,
  GetConversationMessages,
  CreateConversation,
  GetPersonDetails,
  SendMessage,
  GetUsenames,
  GetTipos,
  GetPages,
  GetMetricasResumo,
  GetArchive,
  GetImageId,
  GetVideoId,
  UpdateConversationNickname,
  UpdateHsmMedia
}

export default AtendimentoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/atendimento/atendimento.js